{
    "Rules_Validation_MustBeANumber": "Moet een getal zijn",
    "Rules_Validation_MustBeAnInteger": "Moet een heel getal zijn",
    "Rules_Validation_MustBeGreaterThanZero": "Moet groter zijn dan nul",
    "Rules_Validation_EmailMustBeValid": "E-mail moet geldig zijn",
    "Rules_Validation_MustBeLessThanMaxSafeInteger": "Groter dan de maximaal toegestane waarde",
    "Rules_Validation_MustBeLessThanLimit": "Moet kleiner zijn dan {}",
    "Rules_Validation_MustMatch": "Moet overeenkomen",
    "Rules_Validation_MinLength": "Moet minstens {} tekens lang zijn",
    "Rules_Numbers_MaxSafeInteger": "de maximale gehele waarde",
    "NAME": "RulesLanguage",
    "Rules_Validation_ValidUrl": "Moet een geldige URL zijn",
    "Rules_Validate_Empty": "Dit veld is verplicht",
    "Rules_Validation_MaxLength": "Mag maximaal {} tekens lang zijn",
    "Rules_Validation_MaxWordLength": "Elk woord mag maximaal {} tekens lang zijn",
    "Rules_Validation_IncorrectPattern": "De opgegeven waarde is niet geldig",
    "Rules_Validation_Unique": "De waarde moet uniek zijn",
    "Rules_Validation_ContentType": "Het inhoudstype moet een van de volgende zijn: {}"
}